var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletSmartphoneComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2833:3896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9487 15.7568H124.782V66.2981H83.5407V75.7764H125.164C130.181 75.7764 134.26 71.6989 134.26 66.6822V15.3724C134.26 10.3557 130.181 6.27881 125.164 6.27881H49.5672C44.5505 6.27881 40.4707 10.3557 40.4707 15.3724V31.2741H49.9487V15.7568V15.7568Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5449 88.5542H109.989L118.613 79.9319C119.434 79.1085 120.348 78.447 121.299 77.868H83.5449V88.5542Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.434 48.1661C76.434 42.7702 72.0442 38.3831 66.6487 38.3831H33.813C28.4165 38.3831 24.0273 42.7705 24.0273 48.1661V61.55H28.5791C30.4301 61.55 32.1588 62.0129 33.7208 62.7765L33.8133 47.8608H66.956V93.7468H40.4053V102.693V107.024H65.9238C65.8359 105.566 65.9726 104.113 66.3311 102.693C66.9374 100.3 68.1246 98.0189 69.9963 96.144C70.001 96.1396 70.0036 96.1352 70.0076 96.1303C71.8497 94.2883 74.0851 93.113 76.4337 92.4925V48.1661H76.434ZM47.1765 99.6335C47.1765 97.9441 48.5461 96.5787 50.2308 96.5787C51.9155 96.5787 53.2851 97.9441 53.2851 99.6335C53.2851 101.323 51.9155 102.693 50.2308 102.693C48.5458 102.692 47.1765 101.322 47.1765 99.6335Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5799 67.4734H5.90296C2.64719 67.4734 0 70.1209 0 73.3743V116.34C0 119.594 2.64719 122.241 5.90296 122.241H28.5799C31.8354 122.241 34.4829 119.594 34.4829 116.34V73.3743C34.4826 70.1209 31.8354 67.4734 28.5799 67.4734ZM7.10849 74.5819H27.3741V113.031H7.10849V74.5819ZM14.7351 117.631C14.7351 116.247 15.8552 115.127 17.2436 115.127C18.6228 115.127 19.7428 116.247 19.7428 117.631C19.7428 119.015 18.6228 120.139 17.2436 120.139C15.8552 120.139 14.7351 119.015 14.7351 117.631Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.636 84.9582L96.2596 112.332L85.0856 101.156C82.3134 98.3788 77.8102 98.3788 75.0336 101.156C72.257 103.933 72.257 108.431 75.0336 111.208L91.2334 127.41C92.5666 128.743 94.3734 129.492 96.2596 129.492C98.1453 129.492 99.9527 128.743 101.285 127.41L133.688 95.0096C136.465 92.233 136.465 87.7342 133.688 84.9579C130.911 82.1816 126.413 82.1816 123.636 84.9582Z",
    fill: "#11B7B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2833:3896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.772,
    height: 135.772,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletSmartphoneComputer);
export default __webpack_public_path__ + "static/media/tablet-smartphone-computer.f76d3fd6.svg";
export { ForwardRef as ReactComponent };